// import React, { useState } from "react";
// import "./mainCategories.css";

// export default function AddMainCategoryModal({ onClose, onSave }) {
//   const [name, setName] = useState("");
//   const [status, setStatus] = useState("Active");
//   const [imageFile, setImageFile] = useState(null);
//   const [preview, setPreview] = useState("");
//   const [err, setErr] = useState("");

//   const onFile = (e) => {
//     const f = e.target.files?.[0];
//     if (!f) return;
//     setImageFile(f);
//     setPreview(URL.createObjectURL(f));
//   };

//   const submit = (e) => {
//     e.preventDefault();
//     setErr("");

//     if (!name.trim()) {
//       setErr("Category name required");
//       return;
//     }

//     onSave({
//       name: name.trim(),
//       status,
//       imageFile, // optional
//     });
//   };

//   return (
//     <div className="mc-overlay" onMouseDown={onClose}>
//       <div className="mc-modal" onMouseDown={(e) => e.stopPropagation()}>
//         <div className="mc-modalHead">
//           <h3>Add Main Category</h3>
//           <button className="mc-x" onClick={onClose}>✕</button>
//         </div>

//         <form onSubmit={submit} className="mc-form">
//           {err && <div className="mc-err">{err}</div>}

//           <label className="mc-label">Category Name</label>
//           <input
//             className="mc-input"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="Enter category name"
//           />

//           <label className="mc-label">Status</label>
//           <select
//             className="mc-input"
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//           >
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//           </select>

//           <label className="mc-label">Image</label>
//           <input className="mc-input" type="file" accept="image/*" onChange={onFile} />

//           {preview ? (
//             <img src={preview} alt="preview" className="mc-preview" />
//           ) : (
//             <div className="mc-noimg">No image</div>
//           )}

//           <div className="mc-actionsRow">
//             <button type="button" className="mc-btn ghost" onClick={onClose}>
//               Cancel
//             </button>
//             <button type="submit" className="mc-btn">
//               Save
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

//new

import React, { useState } from "react";
import "./mainCategories.css";

export default function AddMainCategoryModal({ onClose, onSave }) {
  const [name, setName] = useState("");
  const [status, setStatus] = useState("Active");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [err, setErr] = useState("");

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setImageFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const submit = (e) => {
    e.preventDefault();
    setErr("");
    if (!name.trim()) { setErr("Category name is required"); return; }
    onSave({ name: name.trim(), status, imageFile });
  };

  return (
    <div className="mc-overlay" onMouseDown={onClose}>
      <div className="mc-modal" onMouseDown={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="mc-modal-head">
          <div className="mc-modal-head-left">
            <div className="mc-modal-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </div>
            <div>
              <h3 className="mc-modal-title">Add Category</h3>
              <p className="mc-modal-sub">Create a new main category</p>
            </div>
          </div>
          <button className="mc-close-btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Body */}
        <form onSubmit={submit} className="mc-modal-body">
          {err && (
            <div className="mc-form-err">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{flexShrink:0}}>
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {err}
            </div>
          )}

          <div className="mc-form-group">
            <label className="mc-label">Category Name</label>
            <input
              className="mc-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Electronics, Fashion…"
              autoFocus
            />
          </div>

          <div className="mc-form-group">
            <label className="mc-label">Status</label>
            <select className="mc-input mc-select" value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="mc-form-group">
            <label className="mc-label">Category Image <span className="mc-label-opt">(optional)</span></label>
            <label className="mc-file-label">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
              </svg>
              {imageFile ? imageFile.name : "Choose image…"}
              <input type="file" accept="image/*" onChange={onFile} style={{display:"none"}} />
            </label>
            {preview ? (
              <div className="mc-preview-wrap">
                <img src={preview} alt="preview" className="mc-preview" />
                <button type="button" className="mc-preview-remove" onClick={() => { setPreview(""); setImageFile(null); }}>
                  Remove
                </button>
              </div>
            ) : (
              <div className="mc-no-preview">No image selected</div>
            )}
          </div>

          <div className="mc-modal-footer">
            <button type="button" className="mc-btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="mc-btn-save">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Save Category
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}